/* Progressive enhancements. Native product forms, cart requests and recipe content remain authoritative. */
if (!customElements.get('sugarless-gallery')) {
  customElements.define('sugarless-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.items = [...this.querySelectorAll('.product__media-item')];
      this.buttons = [...this.querySelectorAll('[data-sl-media]')];
      this.buttons.forEach(button => button.addEventListener('click', () => this.selectMedia(button.dataset.slMedia)));
      this.selectMedia(this.items[0]?.dataset.mediaId);
      this.classList.add('sl-gallery--ready');
    }
    selectMedia(id) {
      if (!this.items?.some(item => item.dataset.mediaId === id)) return;
      this.items.forEach(item => {
        const active = item.dataset.mediaId === id;
        item.classList.toggle('sl-gallery__active', active);
        if (!active) item.querySelectorAll('video').forEach(video => video.pause());
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slMedia === id)));
    }
  });
}

if (!customElements.get('sugarless-recipe')) {
  customElements.define('sugarless-recipe', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const content = this.querySelector('.article-template__content');
      const tools = this.querySelector('.sl-recipe-tools');
      if (!content || !tools) return;
      // Existing recipes use both headings and bold paragraphs. Preserve their words and order.
      const candidates = [...content.querySelectorAll('h2,h3,h4,p')];
      const ingredients = candidates.find(node => /^ingredients\s*:?$/i.test(node.textContent.trim()));
      const method = candidates.find(node => /^(instructions|method|directions)\s*:?$/i.test(node.textContent.trim()));
      if (ingredients) {
        ingredients.id = 'RecipeIngredients-' + this.dataset.article;
        ingredients.tabIndex = -1;
        ingredients.classList.add('sl-recipe-heading');
        const jump = tools.querySelector('[data-recipe-jump]');
        jump.href = '#' + ingredients.id;
        jump.hidden = false;
        jump.addEventListener('click', () => ingredients.focus({ preventScroll: true }));
        const list = ingredients.nextElementSibling;
        if (list?.matches('ul,ol')) {
          list.classList.add('sl-recipe-ingredients');
          [...list.children].forEach((li, i) => {
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.id = 'Ingredient-' + this.dataset.article + '-' + i;
            const text = document.createElement('span');
            while (li.firstChild) text.appendChild(li.firstChild);
            label.append(input, text);
            li.appendChild(label);
          });
        }
      }
      if (method) {
        method.classList.add('sl-recipe-heading');
        if (method.nextElementSibling?.matches('ol')) method.nextElementSibling.classList.add('sl-recipe-method');
      }
      tools.querySelector('[data-recipe-print]').addEventListener('click', () => window.print());
      tools.hidden = false;
    }
  });
}
